export const GoogleIMA = {

    isPlayling: false,

    destroy: function () {

        clearTimeout(this.timeout);

        this.isPlayling = false;

        if (this.adsLoader) this.adsLoader.destroy();

        if (this.adsManager) this.adsManager.destroy();

        if (this.adContainer) {
            this.adContainer.innerHTML = "";
            this.adContainer.classList.remove("show");
        }

    },

    init: function (data) {

        if (!window.google) return console.log("IMA couldn't be loaded");

        try {

            this.adContainer = data.adContainer;
            this.adContainer.onclick = function (e) {
                e.stopPropagation();
            }
            this.adTagUrl = data.adTagUrl;
            this.events = data.events || {};

            this.destroy();

            this.timeout = setTimeout(function () {
                GoogleIMA.start();
            }, data.timeout || 0);

        } catch (err) {
            this.onAdError(err);
        }

    },

    start: function () {

        this.rect = this.adContainer.getBoundingClientRect();

        this.adDisplayContainer = new window.google.ima.AdDisplayContainer(this.adContainer);

        this.adsLoader = new window.google.ima.AdsLoader(this.adDisplayContainer);

        this.adsLoader.addEventListener(window.google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError, false, this);

        this.adsLoader.addEventListener(window.google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded, false, this);

        this.adDisplayContainer.initialize();

        var adsRequest = new window.google.ima.AdsRequest();

        adsRequest.adTagUrl = this.adTagUrl;
        adsRequest.vastLoadTimeout = 30000;
        adsRequest.setContinuousPlayback = true;

        adsRequest.linearAdSlotWidth = this.rect.width;
        adsRequest.linearAdSlotHeight = this.rect.height;
        adsRequest.nonLinearAdSlotWidth = this.rect.width;
        adsRequest.nonLinearAdSlotHeight = this.rect.height / 3;

        this.adsLoader.requestAds(adsRequest);

    },

    onAdsManagerLoaded: function (adsManagerLoadedEvent) {

        try {

            var adsRenderingSettings = new window.google.ima.AdsRenderingSettings();
            adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;

            this.adsManager = adsManagerLoadedEvent.getAdsManager(null, adsRenderingSettings);

            var adEvents = [
                ["LOADED", this.onAdLoaded],
                ["STARTED", this.onStarted],
                ["COMPLETE", this.onAdEnded],
                ["AD_PROGRESS", this.addProgress],
            ];

            for (var adEvent of adEvents) {

                var event = window.google.ima.AdEvent.Type[adEvent[0]];
                this.adsManager.addEventListener(event, adEvent[1], false);

            }

            this.adsManager.addEventListener(window.google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError, false, this);

            this.adsManager.init(this.rect.width, this.rect.height, window.google.ima.ViewMode.NORMAL);

            this.adsManager.start();

        } catch (adError) {
            console.log("Ad manager could not be started");
            this.onAdError();
        }

    },

    onAdLoaded: function () {
        if (GoogleIMA.adContainer && GoogleIMA.adContainer.firstChild) {
            GoogleIMA.adContainer.firstChild.style.width = "100%";
            GoogleIMA.adContainer.firstChild.style.height = "100%";
        }
    },

    onStarted: function () {
        GoogleIMA.isPlayling = true;
        if (GoogleIMA.adContainer) GoogleIMA.adContainer.classList.add("show");
        if (GoogleIMA.events.onAdStarted) GoogleIMA.events.onAdStarted();
    },

    addProgress: function (event) {
        if (GoogleIMA.events.onAdProgress) GoogleIMA.events.onAdProgress(event);
    },

    onAdEnded: function () {
        GoogleIMA.isPlayling = false;
        if (GoogleIMA.events.onAdEnded) GoogleIMA.events.onAdEnded();
        GoogleIMA.destroy();
    },

    onAdError: function (err) {
        GoogleIMA.isPlayling = false;
        if (GoogleIMA.events.onAdError) GoogleIMA.events.onAdError(err);
        GoogleIMA.destroy();
    },

}


